import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const dashboardsDirectoryRoute: InvariantJiraRoute = {
	name: 'dashboards-directory',
	path: '/jira/dashboards',
};
